<template>
    <div class="ratings">
        <i v-for="(n, index) in fullstars"
            class="fa fa-star"></i>
        <i v-for="(n, index) in emptystars"
            class="fa fa-star-o"></i>
    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'star-display',
    	props: {
    		stars: Number
    	},
    	data: function() {
    		return {
    			totalStars: 5
    		};
    	},
    	computed: {
    		fullstars: function() {
    			return this.stars || 0;
    		},
    		emptystars: function() {
    			return this.totalStars - (this.stars || 0);
    		}
    	}
    };
</script>